/* eslint-disable default-param-last */
import axios from 'axios';
import apiBaseUrl from '../../config/apiBaseUrl';
import { processApiResponse } from '../helper/processApiResponse';
export const optionAPI = {
    Get(params = {
        _id: '',
        optionList: [
            'marketingChannel',
            'hospitalBed',
            'symptom',
            'servedItem',
            'tube',
            'hospitalData',
            'areaAddressData',
            'careOrderTimeSelection',
            'careOrderPlan',
            'fee',
            'makeOffer',
            'cancellation',
        ],
    }, setApiProcessingPool, setApiDonePool, config = {}) {
        const apiRoute = `${apiBaseUrl}/api/client/option/get`;
        return processApiResponse(axios.post(apiRoute, params, config), apiRoute, setApiProcessingPool, setApiDonePool);
    },
};
